var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'fix-ie': _vm.showLoader },attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nprogress-container"}}),_vm._v(" "),(_vm.showLoader)?_c('ald-loader',{attrs:{"text":`${_vm.loaderText}...`}}):_vm._e(),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }